import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Home from "../pages/Home";
import AboutPage from "../pages/AboutPage";
import ServicesPage from "../pages/ServicesPage";
import PortfolioPage from "../pages/PortfolioPage";
import ContactPage from "../pages/ContactPage";
import GalleryPage from "../pages/GalleryPage";
import Admin from "../pages/Admin";
import Flyers from "../components/Flyers";

// GSIDA Components
import GSIDAPresentation from "../components/GSIDA/GSIDAPresentation";
import GSIDATheme from "../components/GSIDA/GSIDATheme";
import GSIDAProgram from "../components/GSIDA/GSIDAProgram";
import GSIDASpeakers from "../components/GSIDA/GSIDASpeakers";
import GSIDAPartners from "../components/GSIDA/GSIDAPartners";
import GSIDAPublications from "../components/GSIDA/GSIDAPublications";
import GSIDAGallery from "../components/GSIDA/GSIDAGallery";

// APSIS Components
import APSISPage from "../components/APSIS/APSISPage";
import APSISRegistration from "../components/APSIS/APSISRegistration";
import APSISExhibitors from "../components/APSIS/APSISExhibitors";
import APSISSecurityInnovation from "../components/APSIS/APSISSecurityInnovation";
import APSISStartups from "../components/APSIS/APSISStartups";
import APSISIndustrialPartners from "../components/APSIS/APSISIndustrialPartners";

// Challenge Components
import DoctoralCompetition from "../components/Challenges/DoctoralCompetition";
import GSIDAwards from "../components/Challenges/GSIDAwards";
import Hackathon from "../components/Challenges/Hackathon";
import PublicInnovation from "../components/Challenges/PublicInnovation";

// Trainings Components
import ExecutivePrograms from "../components/Trainings/ExecutivePrograms";

// Revue RIGSIDA
import RevueRIGSIDA from "../pages/RevueRIGSIDA";

// Publications
import PublicationsPage from "../pages/PublicationsPage";
import PDFRedirect from "../components/PDFRedirect";
import Experts from "../components/Experts";
import ResearchCommittee from "../components/ResearchCommittee";



export default function AppRoutes() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        
        {/* GSIDA Routes */}
        <Route path="/gsida" element={<GSIDAPresentation />} />
        <Route path="/gsida/theme-2026" element={<GSIDATheme />} />
        <Route path="/gsida/program" element={<GSIDAProgram />} />
        <Route path="/gsida/speakers" element={<GSIDASpeakers />} />
        <Route path="/gsida/partners" element={<GSIDAPartners />} />
        <Route path="/gsida/publications" element={<GSIDAPublications />} />
        <Route path="/gsida/gallery" element={<GSIDAGallery />} />

        {/* APSIS Routes */}
        <Route path="/apsis" element={<APSISPage title="About APSIS 2026" tag="ÉVÉNEMENT STRATÉGIQUE" pdfTitle="Plaquette Marketing APSIS 2026" />} />
        <Route path="/apsis/exhibitors" element={<APSISExhibitors />} />
        <Route path="/apsis/security-innovation" element={<APSISSecurityInnovation />} />
        <Route path="/apsis/startups" element={<APSISStartups />} />
        <Route path="/apsis/industrial-partners" element={<APSISIndustrialPartners />} />
        <Route path="/apsis/registration" element={<APSISRegistration />} />

        {/* Trainings Routes */}
        <Route path="/trainings/executive-programs" element={<ExecutivePrograms />} />

        {/* Challenge Routes */}
        <Route path="/challenge/doctoral-competition" element={<DoctoralCompetition />} />
        <Route path="/challenge/awards" element={<GSIDAwards />} />
        <Route path="/challenge/hackathon" element={<Hackathon />} />
        <Route path="/challenge/public-innovation" element={<PublicInnovation />} />

        <Route path="/services" element={<ServicesPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/revue" element={<RevueRIGSIDA />} />
        
        {/* Publications Routes */}
        <Route path="/publications" element={<PublicationsPage />} />
        <Route path="/publications/journals" element={<PDFRedirect pdfUrl="/pdfs/acte-congres-gsida-2026.pdf" />} />
        <Route path="/publications/books" element={<PDFRedirect pdfUrl="/pdfs/rapport-gsida-2025.pdf" />} />
        
        <Route path="/admin" element={<Admin />} />
        <Route path="/flyer" element={<Flyers />} />
        <Route path="/experts" element={<Experts />} />
        <Route path="/research" element={<ResearchCommittee />} />
      </Routes>
      <Footer />
    </Router>
  );
}
